<!-- configures the base values -->
<base-config #baseConfigRef></base-config>

<!-- logout  -->
<div class="user-account-action-menu">
    <div class="profile">
        <div class="profile-avatar"></div>
    </div>
    <div id="profile-dropdown-meu" class="menu shadow">
        <div class="account-basic-info">
            <h3 id="user-account-name">Someone Famous</h3>
            <span id="user-account-role">Website Designer</span>
        </div>
        <ul>
            <!-- <li>
                <img src="./assets/icons/user.png" /><a href="#">My profile</a>
            </li> -->
            <li id="logout-menu-item">
                <div class="icon logout-black-icon"></div>
                <div><a href="#">Logout</a></div>
            </li>
        </ul>
    </div>
</div>

<!-- page loader -->
<app-page-loader></app-page-loader>

<!-- confirm dialog -->
<app-confirm-dialog></app-confirm-dialog>

<!-- confirm dialog -->
<app-confirm-logout-dialog></app-confirm-logout-dialog>

<!-- alert dialog -->
<app-alert-dialog></app-alert-dialog>

<!-- portrait capture alert dialog -->
<!-- <app-portrait-capture-alert-dialog></app-portrait-capture-alert-dialog> -->

<!-- App router -->
<router-outlet></router-outlet>